import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ItineraryData } from '@hiptraveler/data-access/api';
import { ItinerariesDataService } from '@hiptraveler/modules/search-page-root';
import { AppListenerService } from '@hiptraveler/common';
import { opacityFade, opacityFadeIn } from '@hiptraveler/animations';

@Component({
  selector: 'experiences',
  templateUrl: './experiences.component.html',
  viewProviders: [ ItinerariesDataService ],
  animations: [ opacityFade(), opacityFadeIn() ],
})
export class ExperiencesComponent implements OnInit {

  constructor(
    public service: ItinerariesDataService,
    private appListener: AppListenerService
  ) { }

  ngOnInit(): void {
    this.service.initializeDataAccess();
  }

  get skeletons$(): Observable<ItineraryData[]> {
    return this.appListener.clientWidth$.pipe(
      map((clientWidth: number) => clientWidth > 1400 ? Array(6).fill(0) : Array(4).fill(0))
    );
  }

}
